const JobStatus = `
  id
  description
`;

export default JobStatus;
